import React from 'react';
import CommentItem from './CommentItem';
import { Flex, Icon, Button, Spinner } from 'common/styles';
import styled from '@emotion/styled';
import { __t } from '../../i18n';
import { IconDown } from '../../icons';
import { Comment } from '../../apiService';
import { SpacingProps } from '../../withStyleSystem';

export default function CommentList({ contentId, comments, remaining, onShowMore: handleShowMore, loading }: CommentListProps) {
  return (
    <>
      {comments.map((comment, index) => (
        <CommentItem key={index} {...comment} contentId={contentId} />
      ))}
      {remaining > 0 && <ShowMoreButton loading={loading} onClick={handleShowMore} mt={1} />}
    </>
  );
}

export const ShowMoreButton = ({ loading, onClick: handleClick, ...spacing }: ShowMoreButtonProps) => (
  <ButtonContainer align="center" {...spacing}>
    <Button disabled={loading} variant="flat" onClick={handleClick} iconEnd>
      {__t('common.more')}
      <ShowMoreIcon loading={loading} />
    </Button>
  </ButtonContainer>
);

const ShowMoreIcon = ({ loading }: { loading?: boolean }) => {
  if (loading) return <Spinner />;

  return (
    <Icon cursor="pointer">
      <IconDown />
    </Icon>
  );
};

const ButtonContainer = styled(Flex)(() => ({
  '&::before, &::after': {
    content: '""',
    flexGrow: 1,
    borderBottom: '1px solid',
    opacity: 0.25,
  },
}));

type CommentListProps = {
  comments: Comment[];
  remaining: number;
  onShowMore: ShowMoreButtonProps['onClick'];
  loading?: boolean;
  contentId: string;
};

interface ShowMoreButtonProps extends SpacingProps {
  onClick: () => void;
  loading?: boolean;
}
